import { InboundHook } from './types'

export const operands = [
  {
    label: 'equals',
    value: '==',
    keywords: [],
  },
  {
    label: 'does not equal',
    value: '!=',
    keywords: [],
  },
]

// ERRORS
export const ERROR_GET_PHONENUMBERS_SERVER = 'Failed to get phone numbers. Please try again later.'
export const ERROR_GET_PHONENUMBER_SERVER = 'Failed to get phone number rules. Please try again later.'
export const ERROR_UPDATE_PHONENUMBER_SERVER = 'Failed to update phone number. Please try again later.'
export const ERROR_UPDATE_PHONENUMBER_HOOK_SERVER = 'Failed to update phone number rule. Please try again later.'
export const ERROR_ADD_PHONENUMBER_HOOK_SERVER = 'Failed to add phone number rule. Please try again later.'
export const ERROR_DELETE_PHONENUMBER_HOOK_SERVER = 'Failed to delete phone number rule. Please try again later.'

export const defaultNewHook: InboundHook = {
  conditions: {
    unexpected: false,
    conditions: null,
  },
  actions: [],
  id: 0,
  label: '',
}
